export const userRoles = {
  Client: 'client',
  ClientAgent: 'clientAgent',
  Manager: 'manager',
  Trader: 'trader',
  TraderAgent: 'traderAgent'
};
